import { Process } from "../process/process.cls";
/**
 * Basic implementation for a WebSocket wrapper
 */
export class WsConnector extends Process {
    constructor() {
        super(null);
        // HTML5 WebSocket
        this.ws = null;
        // saves the timeout state - pause between re-connects
        this.timeoutTrigger = null;
        this.timeoutTriggerStatus = null;
        this.timeoutStatusInterval = 10000;
        this.timeoutTriggerDisconnect = null;
        // current number of retries to connect to the websocket
        this.currentRetry = 0;
        // default handlers
        this.onopen = (ev) => { this.log(WsConnector.TAG, 'DEF open...', ev); };
        this.onclose = (ev) => { this.log(WsConnector.TAG, 'DEF close...', ev); };
        this.onconnecting = () => { this.log(WsConnector.TAG, 'DEF connecting...'); };
        this.onmessage = (ev) => { this.log(WsConnector.TAG, 'DEF onmessage...', ev); };
        this.onerror = (event) => this.handleError;
        /**
         * connect websocket
         */
        this.connect = () => {
            try {
                // if websocket is already connected - close it
                this.stop();
                // construct full url t owebsocket
                const wsurl = this.settings.ENDPOINT + this.buildQuery();
                this.onconnecting();
                // init webocket
                this.ws = new WebSocket(wsurl);
                // overide handlers
                this.ws.onopen = this.onopen;
                this.ws.onmessage = this.onmessage;
                this.ws.onerror = (event) => {
                    this.handleError(event);
                };
                this.checkStatus();
            }
            catch (ex) {
                this.handleError(ex);
            }
        };
        //checkStatus
        this.checkStatus = () => {
            const _her = this;
            if (this.timeoutTriggerStatus !== null) { // clear timeout
                clearTimeout(this.timeoutTriggerStatus);
                this.timeoutTriggerStatus = null;
            }
            this.timeoutTriggerStatus = setInterval(() => {
                if (_her.ws) {
                    if (_her.ws.readyState == 2 || _her.ws.readyState == 3) {
                        _her.connect();
                        _her.timeoutStatusInterval = 10000;
                        _her.checkStatus();
                        // _her.handleDisconnect()
                    }
                    else if (_her.ws.readyState == 0) {
                        _her.timeoutStatusInterval = 20000;
                        _her.checkStatus();
                    }
                    else if (_her.ws.readyState == 1) {
                        _her.timeoutStatusInterval = 500;
                        _her.checkStatus();
                    }
                }
            }, _her.timeoutStatusInterval);
        };
        /**
         * handle errors and invoke re-ceonncting if configured
         * and we haven't reached number of max retries
         */
        this.handleError = (event) => {
            try {
                if (this.settings.maxRetries == 0
                    || this.currentRetry < this.settings.maxRetries) { // less than max-retries?
                    this.currentRetry++;
                    this.log(WsConnector.TAG, '[' + this.currentRetry + 'of' +
                        this.settings.maxRetries + '] try again in handle error' + this.settings.reconnectInterval + ' ms');
                    if (this.timeoutTrigger !== null) { // clear timeout
                        clearTimeout(this.timeoutTrigger);
                        this.timeoutTrigger = null;
                    }
                    // set new timeout before next re-connect	
                    this.timeoutTrigger = setTimeout(() => {
                        this.connect();
                    }, this.settings.reconnectInterval);
                }
                else { // already reached max
                    this.log(WsConnector.TAG, 'failed to connect websocket after in handle error' +
                        this.settings.maxRetries + ' tries');
                    try {
                        this.stop();
                    }
                    catch (fini) {
                        this.log(WsConnector.TAG, 'websocket closing');
                        // final chutdown of websocket
                    }
                }
            }
            catch (exo) {
                this.log(WsConnector.TAG, 'handleError', exo);
                this.onerror(exo);
            }
        };
        this.handleDisconnect = () => {
            try {
                if (this.settings.maxRetries == 0
                    || this.currentRetry < this.settings.maxRetries) { // less than max-retries?
                    this.currentRetry++;
                    this.log(WsConnector.TAG, '[' + this.currentRetry + 'of' +
                        this.settings.maxRetries + '] try again in ' + this.settings.reconnectInterval + ' ms');
                    // set new timeout before next re-connect 
                    this.connect();
                }
                else { // already reached max
                    this.log(WsConnector.TAG, 'failed to connect websocket after' +
                        this.settings.maxRetries + ' tries');
                    try {
                        this.stop();
                    }
                    catch (fini) {
                        this.log(WsConnector.TAG, 'websocket closing');
                        // final chutdown of websocket
                    }
                }
            }
            catch (exo) {
                this.log(WsConnector.TAG, 'handleError', exo);
                this.onerror(exo);
            }
        };
        this.waitForSocketConnection = (socket, data, callback) => {
            setTimeout(() => {
                try {
                    if (socket.readyState === 1) {
                        if (callback != null) {
                            callback(data);
                        }
                        return;
                    }
                    else {
                        this.waitForSocketConnection(socket, data, callback);
                    }
                }
                catch (ex) {
                    this.waitForSocketConnection(socket, data, callback);
                }
            }, 5);
        };
        this.log(WsConnector.TAG, this.settings);
    }
    /**
     * start process thread
     * used by caches and providers and mains to start all
     * registered providers and caches
     * @param params
     */
    start(params) {
        // console.log(WsConnector.TAG, 'start', params)
        this.settings = params;
        // overide handlers from config
        this.onopen = this.settings.onopen || this.onopen;
        this.onclose = this.settings.onclose || this.onclose;
        this.onconnecting = this.settings.onconnecting || this.onconnecting;
        this.onmessage = this.settings.onmessage || this.onmessage;
        // connect websocket
        this.connect();
    }
    /**
     * stop process thread
     * used by caches and providers and mains to stop all
     * registered providers and caches
     * @param params
     */
    stop(params) {
        this.log(WsConnector.TAG, 'stopping websocket...');
        this.close();
    }
    /**
     * authenticate
     * @param params must contain credentials in case auth is needed
     */
    auth(params) { }
    /**
     * build query in case there are request params
     * in the configuration
     */
    buildQuery() {
        let q = ''; // optional query string
        if (!this.settings.hasOwnProperty('query')) {
            return q;
        }
        if ('query' in this.settings) {
            for (let key in this.settings.query) {
                q += key + '=' + this.settings.query[key] + '&';
            }
        }
        q = (q.length > 1) ? '?' + q.substring(0, q.length - 1) : '';
        return q;
    }
    /**
     * ssend data message to websocket
     * @param data
     */
    send(data, localParams) {
        if (this.ws.readyState === 1) {
            if (localParams !== undefined) {
                localParams.successWs();
            }
            // console.log('ws api',this.ws)
            return this.ws.send(data);
        }
        else {
            // console.log('ws-send 2',this.ws)
            if (localParams) {
                return localParams.failedWs();
            }
            this.waitForSocketConnection(this.ws, data, (data) => {
                try {
                    if (this.ws.readyState === 1) {
                        if (localParams !== undefined) {
                            localParams.successWs();
                        }
                        this.log(WsConnector.TAG, 'send', { endpoint: this.settings.ENDPOINT, data });
                        // console.log('waitForSocketConnection1', data)
                        return this.ws.send(data);
                    }
                    else {
                        // console.log('waitForSocketConnection2', data)
                        if (localParams !== undefined) {
                            localParams.failedWs();
                        }
                        // console.log("this.ws.readyState", this.ws.readyState)
                        // this.connect()
                    }
                }
                catch (ex) {
                    if (localParams !== undefined) {
                        localParams.failedWs();
                    }
                    this.log(WsConnector.TAG, 'send', ex.message);
                }
            });
        }
    }
    /**
     * close websocket
     */
    close() {
        try {
            this.ws.close();
            this.ws = null;
        }
        catch (ex) {
            this.ws = null;
        }
        this.log(WsConnector.TAG, 'stopping websocket ... done');
    }
}
// name of the websocket
WsConnector.TAG = 'WsConnector';



//////////////////
// WEBPACK FOOTER
// ./src/plugins/lib/ws/ws-connector.cls.ts
// module id = null
// module chunks = 